import api from './api';
import {
  ParseResponse,
  IngestResponse,
  DraftListResponse,
  PersonaDraft,
} from '../types/persona_draft';

export const draftBoardService = {
  /** Step 1 of 2: parse text, return extracted items without saving */
  parse: async (text: string): Promise<ParseResponse> => {
    const resp = await api.post('/persona-engine/drafts/parse', { text });
    return resp.data;
  },

  /** Step 2 of 2: save pre-reviewed items to the board */
  ingest: async (items: string[]): Promise<IngestResponse> => {
    const resp = await api.post('/persona-engine/drafts/ingest', { items });
    return resp.data;
  },

  list: async (params?: { limit?: number; offset?: number }): Promise<DraftListResponse> => {
    const resp = await api.get('/persona-engine/drafts', { params });
    return resp.data;
  },

  get: async (id: string): Promise<PersonaDraft> => {
    const resp = await api.get(`/persona-engine/drafts/${id}`);
    return resp.data;
  },

  bulkPrune: async (ids: string[]): Promise<{ pruned: number }> => {
    const resp = await api.post('/persona-engine/drafts/bulk/prune', { ids });
    return resp.data;
  },
};
